/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isObject } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import PropTypes from 'prop-types';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import { ModalContext } from 'App';
import * as actions from '../../../actions';
import * as c from '../../../constant';

function OfficeUpdateModal({
  data,
  updateEndorsingOffice,
  updating,
  getItem,
  id,
  getEndorsingOfficesList,
  status,
  handleEndorsingOffice,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    document_url: '',
    document_number: '',
    amount: '',
  });

  const OnSetFormData = () => {
    setFormData({
      document_url: _.get(data, 'document_url') || '',
      document_number: _.get(data, 'document_number') || '',
      amount: _.get(data, 'endorsed_amount') || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(data)) {
      OnSetFormData();
    }
  }, []);

  const onChangePhoto = (key) => (value) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    handleEndorsingOffice(e);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      amount: _.get(formData, 'amount') ? +_.get(formData, 'amount') : 0,
      endorsing_office_id: _.get(data, 'endorsing_office.id'),
      other_fee_id: _.get(data, 'other_fee_id'),
    };

    updateEndorsingOffice(id, args, () => {
      getEndorsingOfficesList(id);
      setModal({ isOpen: false });
      getItem(id);
      handleEndorsingOffice(e);
    });
  };

  const renderPreview = () => {
    const docUrl = _.get(formData, 'document_url', '');
    if (!docUrl) {
      return (
        <img
          src={ImagePlaceholder}
          alt="preview placeholder"
          className="img-fluid img-thumbnail w-100"
        />
      );
    }

    if (!isObject(docUrl)) {
      if (docUrl.includes('.pdf')) {
        return (
          <iframe
            style={{ width: '100%', height: '500px' }}
            id={docUrl}
            className="img-fluid img-thumbnail"
            src={docUrl}
            title={docUrl}
          />
        );
      }

      return <img className="w-100 rounded" src={docUrl} alt={docUrl} />;
    }

    const formCdnUrl = _.get(formData, 'document_url.cdnUrl', '');
    if (formCdnUrl.includes('.pdf')) {
      return (
        <iframe
          style={{ width: '100%', height: '500px' }}
          id={formCdnUrl}
          className="img-fluid img-thumbnail"
          src={formCdnUrl}
          title={formCdnUrl}
        />
      );
    }

    return <img className="w-100 rounded" src={formCdnUrl} alt={formCdnUrl} />;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">Uploaded Document</label>
            <div className="row d-flex">
              <div className="col-12">{renderPreview()}</div>
              <div className="col-12 mt-2">
                <FilePondSingleUpload
                  onChange={onChangePhoto('document_url')}
                />
                {/* <Uploader
                  className="btn btn-block btn-primary cms-bg-color-primary cms-outline-primary"
                  customLoading={<i className="fas fa-spinner fa-spin" />}
                  icon={<i className="far fa-image" />}
                  label="Upload your reference here"
                  onChange={onChangePhoto('document_url')}
                  imagesOnly
                /> */}
              </div>
            </div>
          </div>
          <div className="col-12 form-group mt-2">
            <label htmlFor="last_name" className="form-label mb-1">
              Document Number
            </label>
            <input
              className="form-control"
              type="text"
              name="document_number"
              onChange={onChange}
              value={_.get(formData, 'document_number') || ''}
            />
          </div>
          {_.get(data, 'status') === 'PENDING' && status !== 'FOR PRINTING' ? (
            <div className="col-12 form-group mt-2">
              <label htmlFor="amount" className="form-label mb-1">
                Amount
              </label>
              <NumberFormat
                name="amount"
                id="amount"
                placeholder="0.00"
                className="form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const prop = {
                    target: {
                      name: 'amount',
                      value,
                    },
                  };
                  onChange(prop);
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                allowNegative
                thousandSeparator
                allowLeadingZeros
                prefix="₱ "
                value={_.get(formData, 'amount')}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
          ) : null}
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

OfficeUpdateModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  updateEndorsingOffice: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  getEndorsingOfficesList: PropTypes.instanceOf(Function).isRequired,
  status: PropTypes.string.isRequired,
  handleEndorsingOffice: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_ENDORSING_OFFICE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(OfficeUpdateModal);
